import { useEffect, useState } from "react";

interface InventoryStatusEditLayoutProps {
    selectedRow: any;
  }
export const InventoryStatusEditLayout = (props:InventoryStatusEditLayoutProps) => {
  const [editValue, setEditValue] = useState("");

  useEffect(() => {
    if (props.selectedRow) {
      setEditValue(props.selectedRow.status); // Populate input field when modal opens
    }
  }, [props.selectedRow]);  
  
  return (
    <div className="row">
      <div>
        <label className="fw-medium">Inventory Status</label>
        <div className="mt-2">
          <input
            tabIndex={2}
            maxLength={50}
            type="text"
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            name="InventoryStatus"
            className="form-control"
            placeholder="Enter Inventory Status"
          />
        </div>
      </div>
    </div>
  );
};


